import { Route } from "react-router-dom";
import { userRoles } from "../../../constants";
import userLayouts from "../../../constants/userLayoutsConsts";
import RequireAuth from "../../requireAuth/RequireAuth";
import renderSuperAdminProtectedRoutes from "./super-admin/renderSuperAdminProtectedRoutes";

const renderProtectedRoutes = (layout) => {
  switch (layout) {
    case userLayouts.IS_AUTH:
      return <></>;
    case userLayouts.IS_MAIN:
      return (
        <>
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  userRoles.SUPER_ADMIN,
                  userRoles.SUPER_ADMIN_ROLES.ACCOUNTANT,
                  userRoles.SUPER_ADMIN_ROLES.CUSTOMER_SUPPORT,
                ]}
              />
            }
          >
            {renderSuperAdminProtectedRoutes({ layout })}
          </Route>
        </>
      );
  }
};

export default renderProtectedRoutes;
